import { getMe, type PlatformUser } from '@/services/users';

export const currentUserQueryKey = (userId: string | undefined) => ['current-user', userId] as const;

/** Shared React Query fetch for `/platform/v1/users/me`. */
export async function fetchCurrentUser(): Promise<PlatformUser | null> {
  try {
    return await getMe();
  } catch {
    return null;
  }
}
